import type {ContributedInstructionKind, ContributedInstructionsMetadata} from './contracts'

export type InstructionScope = 'chat' | 'repository'

export function filterContributedInstructions<T extends {readonly kind: ContributedInstructionKind}>(
  instructions: readonly T[],
  instructionScope: InstructionScope,
): T[] {
  return instructions.filter(instruction => instructionScope === 'repository' || instruction.kind !== 'repository')
}

function instructionOwner(label: string | undefined, ownerUrl: string | undefined): string {
  const normalize = (owner: string) => owner.trim().toLowerCase() || 'unknown'
  if (ownerUrl) {
    try {
      // Metadata owner URLs must be absolute; relative values fall back to the instruction label.
      // eslint-disable-next-line no-restricted-syntax
      const url = new URL(ownerUrl)
      const owner = url.pathname.replace(/^\/+|\/+$/g, '')
      if ((url.protocol === 'https:' || url.protocol === 'http:') && owner) return normalize(owner)
    } catch {
      return normalize(label ?? '')
    }
  }
  return normalize(label ?? '')
}

export function mergeContributedInstructionsMetadata(
  ...snapshots: readonly ContributedInstructionsMetadata[]
): ContributedInstructionsMetadata {
  const merged = new Map<string, ContributedInstructionsMetadata[number]>()
  for (const snapshot of snapshots) {
    for (const {kind, label, ownerUrl} of snapshot) {
      const owner = kind === 'personal' ? '' : instructionOwner(label, ownerUrl)
      const key = `${kind}:${owner}`
      if (merged.has(key)) continue
      merged.set(key, {kind, ...(label ? {label} : {}), ...(ownerUrl ? {ownerUrl} : {})})
    }
  }
  return [...merged.values()]
}
